import { Lang } from 'Roblox';
import angular from 'angular';

const group = angular
  .module('group', [
    'robloxApp',
    'groupDetailsHtmlTemplateApp',
    'groups',
    'ui.bootstrap',
    'cursorPagination',
    'ui.router',
    'modal',
    'socialLinksJumbotron',
    'thumbnails',
    'captchaV2',
    'groupPayouts',
    'groupList',
    'systemFeedback',
    'infiniteScroll'
  ])
  .config([
    '$stateProvider',
    '$urlRouterProvider',
    '$locationProvider',
    'languageResourceProvider',
    function ($stateProvider, $urlRouterProvider, $locationProvider, languageResourceProvider) {
      // validate url
      const loc = window.location.href;
      if (loc.indexOf('#') !== -1 && loc.indexOf('#!') === -1) {
        window.location.href = loc.replace('#', '#!');
      }
      // false mean hashband mode
      $locationProvider.html5Mode(false);
      $locationProvider.hashPrefix('!');
      $urlRouterProvider.otherwise('/about');
      $stateProvider
        .state('about', {
          url: '/about',
          label: 'About',
          authenticate: false
        })
        .state('store', {
          url: '/store',
          label: 'Store',
          authenticate: false
        })
        .state('affiliates', {
          url: '/affiliates',
          label: 'Affiliates',
          authenticate: false
        });

      const resource = Lang.GroupsResources;
      const translationConstants = {
        'Action.MoreGroups': (resource && resource['Action.MoreGroups']) || 'More Groups',
        'Heading.Groups': (resource && resource['Heading.Groups']) || 'Groups',
        'Heading.TwoStepVerificationRequired':
          (resource && resource['Heading.TwoStepVerificationRequired']) || 'Verification Required',
        'Message.TwoStepVerificationRequiredv2':
          (resource && resource['Message.TwoStepVerificationRequiredv2']) ||
          '2-Step Verification is required to make further transactions. Go to your Security page to enable and complete 2-Step Verification.',
        'Action.GoToSecurity': (resource && resource['Action.GoToSecurity']) || 'Go to Security'
      };
      // Localization
      if (Lang.GroupsResources) {
        languageResourceProvider.setLanguageKeysFromFile(Lang.GroupsResources);
        languageResourceProvider.setLanguageKeysFromFile(translationConstants);
      }
      if (Lang.ControlsResources) {
        languageResourceProvider.setLanguageKeysFromFile(Lang.ControlsResources);
      }
      if (Lang.TwoStepVerificationResources) {
        languageResourceProvider.setLanguageKeysFromFile(Lang.TwoStepVerificationResources);
      }
    }
  ]);

export default group;
